var $ = jQuery;
$(document).ready(function() {
  $("#sites-map .marker").not('.eveche').on('click', function(evt) {
    evt.preventDefault();
    $('#site-modal-' + $(evt.target).data('id')).modal();
  });

  if (window.matchMedia('(min-width: 781px)').matches) {
    var $title = $('#front-page-text .wp-block-column:nth-child(2) h2')
    $title.insertAfter($title.siblings('p'))
  }

  $('#page-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    focusOnSelect: true
  });
});